import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, makeStyles } from '@material-ui/core';
import React, { memo, useState } from 'react';
import { useLang } from '../../util/lang';
import Alert from '@material-ui/lab/Alert';
import './modal.css';

export const localColorTheme = {
    purple: '#4D2072',
    white: '#F2F2F3',
    textGrey: '#595757',
    disabled: '#00000061',
};

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        borderRadius: 16, // Set the desired border radius,
        backgroundColor: '#d7d7d7',
    },
}));

const MyBytton = ({ label, defaultLabel, handleDataSave, disabled, outlined = false }) => {
    return (
        <>
            <Button
                onClick={() => handleDataSave()}
                style={{
                    backgroundColor: outlined ? 'auto' : localColorTheme.purple,
                    color: outlined ? 'black' : 'white',
                    borderColor: outlined && 'black',
                    borderWidth: 2,
                    width: 130,
                    height: 36,
                    minHeight: 36,
                    boxSizing: 'border-box',
                    opacity: disabled ? 0.5 : 1,
                    fontWeight: 'bolder',
                    borderRadius: 12,
                    paddingLeft: 8,
                    paddingRight: 8,
                }}
                disabled={disabled}
                variant={outlined ? 'outlined' : 'contained'}
            >
                {label ? label : defaultLabel}
            </Button>
        </>
    );
};

const CustomModal = ({
    isAutoFocus = true,
    title,
    open,
    modalSize = 'md',
    handleClose,
    submitButton,
    handleDataSave,
    submitButtonLabel,
    closeButtonLabel,
    modalError,

    disabledSubmitButton = false,
    disabledCloseButton = false,

    children,
}) => {
    const get = useLang('');
    const classes = useStyles();
    const [submitLoading, setSubmitLoading] = useState(false);

    const handleDataSubmit = async () => {
        try {
            setSubmitLoading(true);
            if (handleDataSave && typeof handleDataSave === 'function') {
                await handleDataSave();
            }
        } catch (error) {
            console.error('Error in handleDataSave: ', error);
        } finally {
            setSubmitLoading(false);
        }
    };

    return (
        <>
            <Dialog
                fullWidth={true}
                // maxWidth={props.modalSize ? props.modalSize : maxWidth}
                maxWidth={'md'}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                onClick={(e) => e.stopPropagation()}
                classes={{ paper: classes.dialogPaper }} // Apply the custom style
            >
                <DialogTitle
                    id="responsive-dialog-title"
                    style={{
                        backgroundColor: localColorTheme.purple,
                        color: 'white',
                        margin: 4,
                        borderTopLeftRadius: 16,
                        borderTopRightRadius: 16,
                        fontWeight: 'bolder',
                        // paddingTop: 30,
                        // paddingBottom: 30
                    }}
                >
                    {title}
                </DialogTitle>

                <DialogContent style={{ backgroundColor: '#d7d7d7' }} className="customModel-hide-scrollbar">
                    {modalError && (
                        <Alert severity="error" style={{ marginBottom: '30px' }}>
                            {modalError}
                        </Alert>
                    )}

                    {children}
                </DialogContent>
                <DialogActions style={{ backgroundColor: '#d7d7d7', paddingBottom: 20 }}>
                    <Grid container spacing={2} style={{ marginLeft: 16 }}>
                        <Grid item style={{ textAlign: 'center' }}>
                            {handleClose && (
                                <MyBytton
                                    label={closeButtonLabel}
                                    defaultLabel={get(':const.close').toUpperCase()}
                                    handleDataSave={handleClose}
                                    disabled={disabledCloseButton}
                                    outlined
                                />
                            )}
                        </Grid>

                        <Grid item style={{ textAlign: 'center' }}>
                            {submitButton && (
                                <MyBytton
                                    label={submitButtonLabel}
                                    defaultLabel={get(':const.save').toUpperCase()}
                                    handleDataSave={handleDataSubmit}
                                    disabled={disabledSubmitButton || submitLoading}
                                />
                            )}
                        </Grid>

                        {/* <Grid item xs={4} style={{ textAlign: 'end' }}>
                        </Grid> */}
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default memo(CustomModal);
